"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhotoUpload = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var cashLoanAuth_1 = require("../../model/cashLoanAuth");
var service_1 = require("../../../library/base/service");
var PhotoUpload = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PhotoUpload, _super);
    function PhotoUpload() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '现金贷身份证上传接口';
        _this.code = '101118';
        _this.desc = '现金贷身份证上传接口';
        _this.requestParams = new cashLoanAuth_1.PhotoUploadRequest();
        _this.method = fetch_1.Methods.POSTFILE;
        return _this;
    }
    return PhotoUpload;
}(service_1.BaseService));
exports.PhotoUpload = PhotoUpload;
//# sourceMappingURL=photoUpload.js.map